var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-week-page"},[_c('calendar',{attrs:{"tasks":_vm.tasks,"stickers":_vm.stickers,"holidays":_vm.holidays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }